import { css } from '@emotion/react';
import {
  type FC, useMemo,
} from 'react';
import { NumberInCircleComponent } from '~/_shared/baseComponents/numberInShape/numberInCircle.component';
import { useTheme } from '~/_shared/themes/theme.hooks';
import { isNullsy } from '~/_shared/utils/typeGuards';

type AccordionStepNumberProps = Readonly<{
  readonly number?: number;
}>;

const itemCountStyle = (number?: number) => css({
  marginRight: 8,
  '::before': {
    content: isNullsy(number) ? 'counter(accordion-item)' : `"${number}"`,
  },
});

export const AccordionStepNumber: FC<AccordionStepNumberProps> = ({ number }) => {
  const theme = useTheme();
  const circleColors = useMemo(() => ({
    fillColor: theme.accordionColors.countBackground,
    fontColor: theme.accordionColors.countColor,
  }), [theme.accordionColors.countBackground, theme.accordionColors.countColor]);

  return (
    <NumberInCircleComponent
      css={itemCountStyle(number)}
      data-element="accordion-number-in-circle"
      colors={circleColors}
      size={20}
    />
  );
};
